import ExpandMore from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ReactNode } from 'react';

interface FuelPriceIndexGroupProps {
  title: string;
  subtitle?: string;
  defaultExpanded: boolean;
  children: ReactNode;
}

export const FuelPriceIndexGroup = ({
  title,
  subtitle,
  defaultExpanded,
  children,
}: FuelPriceIndexGroupProps) => (
  <Accordion defaultExpanded={defaultExpanded} disableGutters elevation={0} square>
    <AccordionSummary expandIcon={<ExpandMore />}>
      <Box>
        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            {subtitle}
          </Typography>
        )}
      </Box>
    </AccordionSummary>
    <AccordionDetails sx={{ p: 0 }}>{children}</AccordionDetails>
  </Accordion>
);
